import * as moment from "moment";
import { MenuItem } from "../interface/user";
import { MatMenuItem } from "@angular/material/menu";
export const getFormattedTime = (date) => moment(date).locale("es").fromNow();

export const imgErrorFallback = (event) => {
  let url = event.target.src;
  if (
    url.includes("%2Fthumbs") ||
    url.includes("_200x200") ||
    url.includes("_400x400")
  ) {
    url = url.replace("%2Fthumbs", "");
    if (url.includes("_200x200")) {
      url = url.replace("_200x200", "");
    }
    if (url.includes("_400x400")) {
      url = url.replace("_400x400", "");
    }
  } else {
    url =
      "https://firebasestorage.googleapis.com/v0/b/tavuel506.appspot.com/o/utilities%2FemptyImg.png?alt=media&token=d3b629c3-3506-4bc7-aef6-21f7ac63b1e8.png";
  }
  event.target.src = url;
};
export const calculateWidth = () => {
  if (window.innerWidth < 400) {
    return "95vw";
  }
  if (window.innerWidth < 800) {
    return "80vw";
  }
  if (window.innerWidth < 1400) {
    return "40vw";
  }
  if (window.innerWidth >= 1400) {
    return "25vw";
  }
  return "auto";
};

export const getInitMenu = (): MenuItem[] => {
  const items: MenuItem[] = [
    {
      id: "17",
      route: "/admin",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "dashboard",
      label: "Dashboard",
      isShow: true,
    },
    {
      id: "29",
      route: "/admin/cellar",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "store",
      label: "Bodegas",
      isShow: true,
    },
    {
      id: "43",
      route: "/admin/blackBox",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "inventory_2",
      label: "Caja Negra",
      isShow: true,
    },
    {
      id: "44",
      route: "/admin/billing/bills",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "receipt",
      label: "Facturación",
      isShow: true,
    },
    {
      id: "42",
      route: "/admin/gallery",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "collections",
      label: "Galería",
      isShow: true,
    },
    {
      id: "41",
      route: "/admin/orders/pending",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "assignment_turned_in",
      label: "Órdenes",
      isShow: true,
    },
    {
      id: "39",
      route: "/reports",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "insert_chart",
      label: "Reportes",
      isShow: true,
    },
    {
      id: "92",
      route: "/reports/user",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      icon: "people",
      label: "Clientes",
      isShow: true,
    },
    {
      id: "58",
      icon: "location_on",
      route: "/admin/place-profile",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      label: "Perfil de la tienda",
      isShow: true,
    },
    {
      id: "76",
      icon: "widgets",
      route: "/admin/tags",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      label: "Categorias",
      isShow: true,
    },
    {
      id: "83",
      icon: "person",
      route: "/admin/users",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      label: "Administradores",
      isShow: true,
    },
    {
      id: "89",
      icon: "request_quote",
      route: "/admin/billing-profile-place",
      access: ["Read", "Edit", "Delete", "Create", "All"],
      label: "Perfil de facturación",
      isShow: true,
    },
  ];
  return items;
};
export function formatDate(isoDate: string): string {
  const date = new Date(isoDate);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  return `${day}-${month}-${year}`;
}
